import Script from 'next/script';
import styles from './TrustPilot.module.css';

type Variant = 'dark' | 'light';

const BUSINESS_UNIT_ID = '4fca033e0000640005160149';
const TRUSTPILOT_URL = 'https://uk.trustpilot.com/review/tempcover.com';

export enum TrustpilotLayouts {
  Mini = 'mini', // https://help.trustpilot.com/s/article/TrustBox-widget-overview?language=en_US#mini
  Micro = 'micro', // https://help.trustpilot.com/s/article/TrustBox-widget-overview?language=en_US#micro-combo
  List = 'list', // https://help.trustpilot.com/s/article/TrustBox-widget-overview?language=en_US#list
  MicroReviewCount = 'microReviewCount', // https://help.trustpilot.com/s/article/TrustBox-widget-overview?language=en_US#micro-review-count
}

export type TrustpilotLayoutType = (typeof TrustpilotLayouts)[keyof typeof TrustpilotLayouts];

const TrustPilotWidget = ({
  variant = 'light',
  layout = TrustpilotLayouts.Micro,
}: {
  variant?: Variant;
  layout?: TrustpilotLayoutType;
}) => {
  const variantClasses = {
    dark: 'bg-primary !text-white',
    light: '',
  };

  let content;

  if (layout === TrustpilotLayouts.MicroReviewCount) {
    content = (
      <div className={styles.microReviewCount}>
        <div
          className="trustpilot-widget"
          data-locale="en-GB"
          data-template-id="5419b6a8b0d04a076446a9ad"
          data-businessunit-id={BUSINESS_UNIT_ID}
          data-style-height="24px"
          data-style-width="100%"
          data-theme={variant}
        >
          <a href={TRUSTPILOT_URL} target="_blank" rel="noopener">
            Trustpilot
          </a>
        </div>
      </div>
    );
  } else if (layout === TrustpilotLayouts.List) {
    content = (
      <div
        className="trustpilot-widget"
        data-locale="en-GB"
        data-template-id="539ad60defb9600b94d7df2c"
        data-businessunit-id={BUSINESS_UNIT_ID}
        data-style-height="500px"
        data-style-width="100%"
        data-theme="light"
        data-stars="1,2,3,4,5"
        data-review-languages="en"
      >
        <a href={TRUSTPILOT_URL} target="_blank" rel="noopener">
          Trustpilot
        </a>
      </div>
    );
  } else if (layout === TrustpilotLayouts.Mini) {
    content = (
      <div
        className="trustpilot-widget"
        data-locale="en-GB"
        data-template-id="53aa8807dec7e10d38f59f32"
        data-businessunit-id={BUSINESS_UNIT_ID}
        data-style-width="255px"
        data-style-height="110px"
        data-theme={variant}
      >
        <a href={TRUSTPILOT_URL} target="_blank" className="hidden" rel="noopener">
          Trustpilot
        </a>
      </div>
    );
  } else {
    content = (
      <div className="xs:py-2 xs:h-10 mx-auto h-14 overflow-hidden px-4 py-1 text-center">
        <div
          className="trustpilot-widget hidden lg:block"
          data-locale="en-GB"
          data-template-id="5419b6ffb0d04a076446a9af"
          data-businessunit-id={BUSINESS_UNIT_ID}
          data-style-height="24px"
          data-style-width="100%"
          data-theme={variant}
        >
          <a href={TRUSTPILOT_URL} target="_blank" className="hidden" rel="noopener">
            Trustpilot
          </a>
        </div>
        <div
          className="trustpilot-widget block lg:hidden"
          data-locale="en-GB"
          data-template-id="5419b732fbfb950b10de65e5"
          data-businessunit-id={BUSINESS_UNIT_ID}
          data-style-width="100%"
          data-theme={variant}
        >
          <a href={TRUSTPILOT_URL} target="_blank" className="hidden" rel="noopener">
            Trustpilot
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className={`${variantClasses[variant]}`}>
      {content}
      <Script
        id="trustpilot-bootstrap"
        src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        strategy="lazyOnload"
      />
    </div>
  );
};

export default TrustPilotWidget;
